import {
  ExpandDownIcon,
  IconButton,
  IconButtonColorEnum,
  IconButtonShapeEnum,
  IconButtonSizeEnum,
  IconSizeEnum,
  Tooltip,
} from '@acceso/design-system';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

type CollapseAllButtonProps = {
  isExpanded: boolean;
  onClick: () => void;
};

export function CollapseAllButton({ isExpanded, onClick }: CollapseAllButtonProps) {
  const { t } = useTranslation();
  return (
    <Tooltip
      help={isExpanded ? t('Contraer todos los grupos') : t('Expandir todos los grupos')}
      grow
    >
      <IconButton
        onClick={onClick}
        color={IconButtonColorEnum.NONE_DEFAULT}
        shape={IconButtonShapeEnum.SQUARED}
        size={IconButtonSizeEnum.SM}
      >
        <ExpandDownIcon
          size={IconSizeEnum.XS}
          className={clsx(
            'cursor-pointer transition-transform duration-200',
            isExpanded && 'rotate-180'
          )}
        />
      </IconButton>
    </Tooltip>
  );
}
